module.exports = __webpack_public_path__ + "img/76-5445cb.png";